// US phone numbers format themselves as you type (Kloepfer K8-8, Larry
// 2026-10-08): 2085550143 → (208) 555-0143. Only a plain US number is
// touched; anything with a plus sign, letters (an extension) or more than
// ten digits is left exactly as typed - US companies only (Phelipe: "this
// kinda tricky for international").

// The ten digits of a US number, or null when this isn't one.
export function usDigits(raw) {
  const text = String(raw ?? "")
  if (/[a-z+]/i.test(text)) return null
  let digits = text.replace(/\D/g, "")
  if (digits.length === 11 && digits.startsWith("1")) digits = digits.slice(1)
  if (digits.length > 10) return null
  return digits
}

// "(208) 555-01" while typing, "(208) 555-0143" when done.
export function formatUsDigits(digits) {
  if (!digits) return ""
  if (digits.length <= 3) return `(${digits}`
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
}

// A stored number, for showing: formatted when it's a US number, else as is.
export function formatUsPhone(raw) {
  const digits = usDigits(raw)
  return digits && digits.length === 10 ? formatUsDigits(digits) : String(raw ?? "")
}
